<template>
  <svg
    width="1900"
    height="895"
    viewBox="0 0 1900 895"
    fill="transparent"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      opacity="0.11"
      filter="url(#filter0_f)"
    >
      <path
        :d="firstPath"
        stroke="#4745D5"
        stroke-width="200"
      />
    </g>
    <g
      opacity="0.15"
      filter="url(#filter0_f)"
    >
      <path
        :d="secondPath"
        stroke="#0095DD"
        stroke-width="200"
      />
    </g>
    <defs>
      <filter
        id="filter0_f"
        x="-215.179"
        y="0.678711"
        width="2332.73"
        height="992.723"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="50"
          result="effect1_foregroundBlur"
        />
      </filter>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'WaveBackground',
  data() {
    return {
      firstPath: 'M-71.8737 453.669C10.6714 489.891 413.452 580.109 803.509 473.363C1145.73 379.708 1339.02 460.891 1503.03 461.144C1548.17 458.747 1709.18 471.002 1992.08 539.205',
      secondPath: 'M-51.9806 339.073C122.651 309.436 598.188 225.31 999.426 417.505C1392.61 605.84 1793.88 742.061 1957.33 757.939',
    };
  },
};
</script>
